import React from "react";
import { Image, Input } from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import plus from "../../assets/svg/plus_white.svg";
import { inputStyle } from "../../lib/styles/styleLibrary";
// import { useMediaQuery } from "react-responsive";

const NewSectionWrapper = styled.div`
	${tw`p-2 md:p-8 md:pt-4 h-full bg-white w-full flex flex-col container`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}
`;

const InviteSection = (props) => {
	// const isMobile = useMediaQuery({ maxWidth: 1217 });

	return (
		<NewSectionWrapper>
			{
				<div>
					<h3
						tw="font-semibold tracking-wider"
						style={{ fontSize: "15px" }}>
						Add New Section
					</h3>

					<div tw="flex flex-col flex-nowrap gap-2 md:(inline-flex gap-4 flex-row) mt-4 w-full ">
						<Input
							placeholder="Add Venue"
							type="text"
							css={inputStyle}
							tw="w-full text-xs! rounded-md"
							suffix={
								<Image
									preview={false}
									src={plus}
									alt=""
									width={25}
									height={25}
									tw="pl-2"
								/>
							}
						/>
						<Input
							placeholder="Add Time "
							type="text"
							css={inputStyle}
							tw="w-full text-xs! rounded-md"
							suffix={
								<Image
									preview={false}
									src={plus}
									alt=""
									width={25}
									height={25}
									tw="pl-2"
								/>
							}
						/>
					</div>

					<div tw="flex flex-col flex-nowrap gap-2 md:(inline-flex gap-4 flex-row) w-full">
						<Input
							placeholder="RSVP"
							type="text"
							css={inputStyle}
							tw="w-full text-xs! rounded-md"
							suffix={
								<Image
									preview={false}
									src={plus}
									alt=""
									width={25}
									height={25}
									tw="pl-2"
								/>
							}
						/>

						<Input
							placeholder="Colour code"
							type="text"
							css={inputStyle}
							tw="w-full text-xs! rounded-md"
							suffix={
								<Image
									preview={false}
									src={plus}
									alt=""
									width={25}
									height={25}
									tw="pl-2"
								/>
							}
						/>
					</div>

					<div tw="mt-2">
						<p tw="text-sm tracking-wider">Theme</p>
						<div tw="flex flex-wrap gap-4 items-center">
							<span
								tw="h-10 w-10 rounded-full border-none"
								css={{ background: "#EEEEEE" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#000000" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#00B6AA" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#FF5A62" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#FFB800" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#A27BF6" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#29D697" }}
							/>
							<span
								tw="h-8 w-8 rounded-full border-none"
								css={{ background: "#3D50DF" }}
							/>
							<span tw="relative cursor-pointer">
								<input
									type="color"
									placeholder="+"
									id="color-picker-tool"
									tw="h-10 w-10 rounded-full p-4 z-50 border-none"
									value="#FF5A62"
									onChange={() => {}}
								/>
								<span tw="inline-block font-bold text-sm text-white absolute z-0 left-4 m-0 p-0 top-2.5">
									+
								</span>
							</span>
						</div>
					</div>
				</div>
			}
		</NewSectionWrapper>
	);
};

export default InviteSection;
